import { render, staticRenderFns } from "./general-info-tab.vue?vue&type=template&id=c33b4a74&scoped=true"
import script from "./general-info-tab.vue?vue&type=script&lang=js"
export * from "./general-info-tab.vue?vue&type=script&lang=js"
import style0 from "./general-info-tab.vue?vue&type=style&index=0&id=c33b4a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b4a74",
  null
  
)

export default component.exports